import {SxType} from "@baseTypes/sx/sxTypes";

const DANGER_COLOR = '#d32f2f'
const DANGER_COLOR_HOVER = '#b02525'

export const sx: SxType = {
	dangerPaper: {
		borderTop: `4px solid ${DANGER_COLOR}`,
	},
	dangerTitle: {
		color: DANGER_COLOR,
		fontWeight: '700',
	},
	dangerIcon: {
		color: DANGER_COLOR,
	},
	dangerMessage: {
		fontWeight: '600',
	},
	// set through sx rather than the color prop: ButtonCustom drops color in the dark theme
	dangerButton: {
		backgroundColor: DANGER_COLOR,
		color: '#fff',
		'&:hover': {
			backgroundColor: DANGER_COLOR_HOVER,
		},
	},
}
